import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { CatalogoCuartilDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class CatalogoCuartilService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getCatalogoCuartilService(): Observable<BodyListResponse<CatalogoCuartilDTO>> {
    return this.http.get<BodyListResponse<CatalogoCuartilDTO>>(API_URL + '/api/v1/catalogoCuartil/todos');
  }

  guardarCatalogoCuartilService(catalogoCuartilDTO: CatalogoCuartilDTO): Observable<BodyResponse<CatalogoCuartilDTO>> {
    return this.http.post<BodyResponse<CatalogoCuartilDTO>>(API_URL + '/api/v1/catalogoCuartil', catalogoCuartilDTO);
  }

  getCatalogoCuartilPorCodigoCuartilService(codigoCuartil: string): Observable<BodyResponse<CatalogoCuartilDTO>> {
    return this.http.get<BodyResponse<CatalogoCuartilDTO>>(API_URL + '/api/v1/catalogoCuartil/' + codigoCuartil);
  }
}
